exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ou_dKNLV_FA4zh3J3ETZr{display:flex;justify-content:center}._1-wEugBJirMaEsxvgDDpI3{display:flex}.vdQvgu3BpFasGwc1NYXGM{width:100%;height:150px;padding:10px}\n", ""]);

// Exports
exports.locals = {
	"body": "ou_dKNLV_FA4zh3J3ETZr",
	"footer": "_1-wEugBJirMaEsxvgDDpI3",
	"embedCode": "vdQvgu3BpFasGwc1NYXGM"
};